// extracted by mini-css-extract-plugin
module.exports = {"paymentPlan":"partialPayment_paymentPlan__2Fi15","question":"partialPayment_question__1kbX8","error":"partialPayment_error__1rdUh"};